import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  FormControl,
  Select,
  MenuItem,
  Menu,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import { Tooltip } from "@mui/material";
import Close from "../../../assets/icons/Close.svg";
import ButtonClose from "../../../assets/icons/ButtonClose.svg";
import Calander from "../../../assets/icons/Calander.svg";
import moment from "moment";
import { DateEditCalendar } from "../../CommonComponent/DateEditCalendar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import {
  getChecklistTypeMastersList,
  getVesselMasterList,
  getDepartmentMasterList,
  addChecklistMastersList,
  getAllQuestionChecklistMastersList,
} from "../../../redux/actions/mastersAction";
import {
  Engine_Weekly,
  Engine_Daily,
  Deck_Daily,
  Deck_Weekly,
  Engine_Monthly,
  Deck_Monthly,
} from "../../../utils/AllQuestion";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const AddChecklistModel = (Props) => {
  const dispatch = useDispatch();
  const CompanyID = localStorage.getItem("companyID");
  const checklistTypeMasterData = useSelector(
    (state) => state?.masters?.checklistTypeMasterData
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );

  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const allChecklistQuestionMasterData = useSelector(
    (state) => state?.masters?.allChecklistQuestionMasterData
  );

  console.log("vjkoajgpojpijg", allChecklistQuestionMasterData);
  const [ChecklistType, setChecklistType] = useState("");
  const [Department, setDepartment] = useState("");
  const [VesselName, setVesselName] = useState("");
  // const [AddQuestion, setAddQuestion] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState([]);
  const [checklistDate, setchecklistDate] = useState(
    moment().format("DD MMM, YYYY")
  );
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);

  const handleChangeAddQuestion = (event) => {
    const selectedNo = event.target.value;
    const selectedQuestionObj = allChecklistQuestionMasterData.find(
      (row) => row?.id === selectedNo
    );

    const isselectedQuestion = selectedQuestion.find(
      (row) => row?.id === selectedNo
    );
    if (!isselectedQuestion) {
      setSelectedQuestion([
        ...selectedQuestion,
        {
          id: selectedQuestionObj?.id,
          question: selectedQuestionObj?.question,
          company_id: selectedQuestionObj?.company_id,
        },
      ]);
    }
  };

  const removeSelectedQuestion = (id) => {
    const updatedQuestions = selectedQuestion.filter((row) => row.id !== id);
    setSelectedQuestion(updatedQuestions);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const checklistDatefilter = (e) => {
    setchecklistDate(moment(e).format("DD MMM, YYYY"));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeChecklistType = (event) => {
    // const filteredChecklistType = checklistTypeMasterData.filter(
    //   (row) => row?.id === event.target.value
    // );
    // setCurrentChecklistName(filteredChecklistType[0]?.name);
    setChecklistType(event.target.value);
  };

  const handleChangeDepartment = (event) => {
    // const filteredDepartment = departmentMasterData.filter(
    //   (row) => row?.id === event.target.value
    // );
    // setCurrentDepartmentName(filteredDepartment[0]?.name);
    setDepartment(event.target.value);
  };

  const handleChangeVesselType = (event) => {
    setVesselName(event.target.value);
  };

  useEffect(() => {
    dispatch(
      getChecklistTypeMastersList({
        limit: "",
        offset: "",
      })
    );
    dispatch(
      getVesselMasterList({
        active: "",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
  }, []);

  useEffect(() => {
    // if (ChecklistType !== "" && Department !== "") {
    dispatch(
      getAllQuestionChecklistMastersList({
        ChecklistId: ChecklistType,
        DepartmentId: Department,
      })
    );
    // }
  }, [ChecklistType, Department]);

  // useEffect(() => {
  //   if (
  //     CurrentChecklistName === "Daily" &&
  //     CurrentDepartmentName === "Engine"
  //   ) {
  //     setAddQuestion(Engine_Daily);
  //   } else if (
  //     CurrentChecklistName === "Weekly" &&
  //     CurrentDepartmentName === "Engine"
  //   ) {
  //     setAddQuestion(Engine_Weekly);
  //   } else if (
  //     CurrentChecklistName === "Monthly" &&
  //     CurrentDepartmentName === "Engine"
  //   ) {
  //     setAddQuestion(Engine_Monthly);
  //   } else if (
  //     CurrentChecklistName === "Daily" &&
  //     CurrentDepartmentName === "Deck"
  //   ) {
  //     setAddQuestion(Deck_Daily);
  //   } else if (
  //     CurrentChecklistName === "Weekly" &&
  //     CurrentDepartmentName === "Deck"
  //   ) {
  //     setAddQuestion(Deck_Weekly);
  //   } else if (
  //     CurrentChecklistName === "Monthly" &&
  //     CurrentDepartmentName === "Deck"
  //   ) {
  //     setAddQuestion(Deck_Monthly);
  //   }
  // }, [ChecklistType, Department]);

  function truncateText(text, maxLength) {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    if (
      // ChecklistName !== "" &&
      ChecklistType !== "" &&
      Department !== "" &&
      VesselName !== "" &&
      selectedQuestion?.length !== 0
    ) {
      dispatch(
        addChecklistMastersList({
          // name: ChecklistName,
          checklist_type_id: ChecklistType,
          vessel_id: VesselName,
          published_at: dayjs(checklistDate, "DD MMM, YYYY").format(),
          company_id: CompanyID,
          department_id: Department,
          selectedQuestion: selectedQuestion,
        })
      );
      Props.handleCloseAddChecklistModel();
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  return (
    <Modal
      open={Props.isAddChecklistModel}
      onClose={() => Props.handleCloseAddChecklistModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add Checklist
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={Props.handleCloseAddChecklistModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          {/* <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Checklist Name"
                type="text"
                value={ChecklistName}
                onChange={handleChangeChecklistName}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  outline: "none",
                  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                    height: "0.4375em",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .css-1v4ccyo": {
                    height: "2.5rem",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Box> */}
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                name="outlet"
                value={ChecklistType}
                onChange={handleChangeChecklistType}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  color: "#000000",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Checklist type
                </MenuItem>
                {checklistTypeMasterData.map((row) => (
                  <MenuItem value={row?.id}>
                    {row?.name}({row?.department_info?.name})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            <Box
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => handleClick(event)}
              sx={{
                background: "#F3F6F9",
                borderRadius: "8px",
                // width: "9rem",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                border: "none",
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "14px",
                  cursor: "pointer",
                  border: "none",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                aria-haspopup="true"
              >
                {checklistDate ||
                  moment().startOf("year").format("DD MMM, YYYY")}
              </Typography>
              <img src={Calander} width="20" height="20" />
            </Box>
            {open && (
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <DateEditCalendar
                  handleCloseCalendar={handleClose}
                  saveTheDate={checklistDatefilter}
                  date={checklistDate}
                />
              </Menu>
            )}
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                name="outlet"
                value={Department}
                onChange={handleChangeDepartment}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  color: "#000000",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Department Name
                </MenuItem>
                {departmentMasterData?.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                name="outlet"
                value={VesselName}
                onChange={handleChangeVesselType}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  color: "#000000",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Vessel Name
                </MenuItem>
                {vesselMasterData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                name="outlet"
                value={selectedQuestion}
                onChange={handleChangeAddQuestion}
                displayEmpty
                disabled={ChecklistType === "" || Department === ""}
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  color: "#B5B5C3",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      // width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                MenuProps={{
                  sx: {
                    ".MuiList-root": {
                      maxHeight: "270px",
                      // width: "300px",
                      wordBreak: "break-word",
                    },
                    ".MuiMenuItem-root": {
                      overflowWrap: "break-word",
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select a question...
                </MenuItem>
                {allChecklistQuestionMasterData?.map((row) => (
                  <MenuItem value={row?.id}>
                    <Tooltip title={row?.question} arrow>
                      <span>{truncateText(row?.question, 85)}</span>
                    </Tooltip>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Divider sx={{ marginBottom: "20px" }} />
          <Grid
            container
            spacing={2}
            sx={{
              overflow: "auto",
              height: "10rem",
              padding: "0px 10px 0px 10px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {selectedQuestion?.map((row, index) => (
              <Grid
                item
                xs={12}
                md="auto"
                key={row.seq_no}
                sx={{
                  flexWrap: "wrap",
                  overflow: "auto",
                  display: "flex",
                }}
              >
                <Stack direction="row" alignItems="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "auto",
                      backgroundColor: "#26875C",
                      borderRadius: "10px",
                      padding: "8px 10px 8px 10px",
                      cursor: "pointer",
                      gap: "10px",
                    }}
                  >
                    <Box>
                      <Tooltip title={row.question}>
                        <Typography
                          align="center"
                          sx={{
                            fontSize: "14px",
                            color: "#FFFFFF",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {truncateText(row.question, 50)}
                        </Typography>
                      </Tooltip>
                    </Box>
                    <Box>
                      <img
                        src={ButtonClose}
                        alt=""
                        width="10"
                        height="10"
                        onClick={() => removeSelectedQuestion(row?.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </Box>
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={Props.handleCloseAddChecklistModel}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <Button
                // variant="contained"
                onClick={onSubmit}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddChecklistModel;
